import React from 'react';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import frLocale from '@fullcalendar/core/locales/fr';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import './styles.css';

//import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import moment from 'moment';
import { newDataEmployeeManagement, isHasPermission } from '../../utils/helpres';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { sortCities } from '../../utils/constants';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import actions from '../agenda/store/actions';
import actionsJs from '../../js/actions';
import actionsM from '../messenger/store/actions';
import actionsPatient from '../patient/store/actions';
import actionsCure from '../consultations/store/actions';
import { connect } from 'react-redux';
import SwipeableDrawerCreate from './swipeable-drawer-create';
import SwipeableDrawerUpdate from './swipeable-drawer-update';
import SwipeableDrawerDuplicate from './duplicate-appointment';
import InputField from '../../components/inputField';
import Alert from '@mui/material/Alert';
import { toast } from 'react-toastify';
import ToastAction from '../../components/ToastAction';

const mapStateToProps = (state) => ({
  loadingAddSessions: state.ConsultationReducer.loadingAddSessions,
  office: state.AppReducer.office,
  isLoadingDuplicateRdv: state.AgendaReducer.isLoadingDuplicateRdv,
  duplicateRdv: state.AgendaReducer.duplicateRdv,
  DestroyUnavailability: state.AgendaReducer.deleteUnavailability,
  isLoadingGetAllUnavailability: state.AgendaReducer.isLoadingGetAllUnavailability,
  isLoadingGetAllRDV: state.AgendaReducer.isLoadingGetAllRDV,
  isLoadingAddRdv: state.AgendaReducer.isLoadingAddRdv,
  created: state.AgendaReducer.created,
  canceledRdv: state.AgendaReducer.canceledRdv,
  isLoadingAddDispo: state.AgendaReducer.isLoadingAddDispo,
  createdNewDispo: state.AgendaReducer.createdNewDispo,
  isLoadingDeleteRDV: state.AgendaReducer.isLoadingDeleteRDV,
  deleteRDV: state.AgendaReducer.deleteRDV,
  getListUnavailability: state.AgendaReducer.getAllUnavailability,
  motifsAgenda: state.AgendaReducer.motifsAgenda,
  getAllRDV: state.AgendaReducer.getAllRDV,
  params: state.AgendaReducer.params,
  paymentAction: state.AgendaReducer.paymentAction,
  paramsDoctor: state.MessengerReducer.params,
  isLoadingDoctors: state.MessengerReducer.isLoadingDoctors,
  doctors: state.MessengerReducer.doctors,
  getLastAvailabilityDate: state.AgendaReducer.getLastAvailabilityDate,
  employeeManagement: state.AppReducer.employeeManagement,
  isLoadingHolidayEmployeeManagement: state.AppReducer.isLoadingHolidayEmployeeManagement,
  paymentRdv: state.AppReducer.payment,
  user: state.AppReducer.user,
  isLoadingAbsenceHours: state.AppReducer.isLoadingAbsenceHours,
  absenceHours: state.AppReducer.absenceHours,
  activeItemSideBarRDV: state.AppReducer.activeItemSideBarRDV,
  detailtPyamentRdv: state.AgendaReducer.detailtPyamentRdv,
  isLoadingDetailtPyamentRdv: state.AgendaReducer.isLoadingDetailtPyamentRdv,
  paramsPatients: state.PatientReducer.params,
  isLoadingPatientRecords: state.PatientReducer.isLoadingPatientRecords,
  patientRecords: state.PatientReducer.patientRecords,
  patientStatistical: state.PatientReducer.patientStatistical,
  allSessionsPatient: state.ConsultationReducer.allSessionsPatient,
  isLoadingAllSessionsPatient: state.ConsultationReducer.isLoadingAllSessionsPatient,
  medecins: state.AppReducer.medecins,
  updateConsultation: state.ConsultationReducer.updateConsultation,
  addPec: state.ConsultationReducer.addPec,
});

const mapDispatchToProps = (dispatch) => ({
  submitFormPEC: async (params, values, id) => {
    await dispatch(actionsCure.submitFormPEC(values));
    setTimeout(() => {
      dispatch(actions.getAllRdv(params, id));
    }, 1000);
  },
  getMedecins: () => dispatch(actionsJs.getMedecins()),
  createConsultation: async (params, values, id) => {
    await dispatch(actionsCure.addConsultation(values));
    setTimeout(() => {
      dispatch(actions.getAllRdv(params, id));
    }, 1000);
  },
  getPatientSessions: async (id) => {
    await dispatch(actionsCure.getPatientSessions(id));
  },
  getPatientStatistical: (id) => dispatch(actionsPatient.getPatientStatistical(id)),
  getLastAvailability: (id, doctor_id) =>
    dispatch(actions.getLastAvailability(id, doctor_id)),
  getDipoDoctorByMotif: (valuse) => dispatch(actions.getDipoDoctorByMotif(valuse)),
  getAllRdvByDay: (params, id) => dispatch(actions.getAllRdv(params, id)),
  getAbsensesByHours: (values, id) => dispatch(actionsJs.getAbsensesByHours(values, id)),
  getAllDoctors: (params) => dispatch(actionsM.getAllDoctors(params)),
  getMotif: () => dispatch(actions.getMotif(null)),
  getDetailtPaymentAppointment: (id) =>
    dispatch(actions.getDetailtPaymentAppointment(id)),
  submitRDVForm: async (params, values, id) => {
    await dispatch(actions.submitRDVForm(values));
    setTimeout(() => {
      dispatch(actions.getAllRdv(params, id));
    }, 1000);
  },
  duplicateRDVForm: async (params, values, id) => {
    await dispatch(actions.duplicateRDVForm(values));
    setTimeout(() => {
      dispatch(actions.getAllRdv(params, id));
    }, 1000);
  },
  submitPaymentForm: async (params, values, id) => {
    await dispatch(actions.submitPaymentForm(values));
    setTimeout(() => {
      dispatch(actions.getAllRdv(params, id));
    }, 1000);
  },
  deleteRdv: async (params, id, ids) => {
    await dispatch(actions.deleteRdv(id));
    dispatch(actions.getAllRdv(params, ids));
  },
  deleteSession: async (id, patientId) => {
    await dispatch(actions.deleteRdv(id));
    await dispatch(actionsCure.getPatientSessions(patientId));
  },
  changeDate: async (params, id) => {
    await dispatch(actions.changeParams(params));
    //dispatch(actions.getAllUnavailability(params));
    dispatch(actions.getAllRdv(params, id));
  },
  changeStatusRdv: async (params, ids) => {
    await dispatch(actions.changeParams(params));
    //dispatch(actions.getAllUnavailability(params));
    dispatch(actions.getAllRdv(params, ids));
  },
  changeType: async (params, id) => {
    await dispatch(actions.changeParams(params));
    //dispatch(actions.getAllUnavailability(params));
    dispatch(actions.getAllRdv(params, id));
  },
  getEmployeeManagement: (type) => dispatch(actionsJs.getEmployeeManagement(type)),
  changeActiveItemSideBarSettings: (item, data, create) =>
    dispatch(actionsJs.changeActiveItemSideBarSettings(item, data, create)),
  changeActiveItemSideBarCompta: (data) =>
    dispatch(actionsJs.changeActiveItemSideBarCompta(data)),
  changeSearched: async (params) => {
    await dispatch(actionsPatient.changeSearchedString(params));
    dispatch(actionsPatient.getPatientRecordsByDoctor(params));
  },
  changeSearchedString: async (params) => {
    await dispatch(actionsPatient.changeSearchedString(params));
  },
  getOfficeByIdDoctor: () => dispatch(actionsJs.getOfficeByIdDoctor()),
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const EventDetail = (eventInfo) => {
  let pathologie = '',
    pathologieColor = '#000000';
  try {
    pathologie =
      eventInfo.event._def.extendedProps.motif &&
      eventInfo.event._def.extendedProps.motif.label === 'Autre'
        ? eventInfo.event._def.extendedProps.diagnostic
        : eventInfo.event._def.extendedProps.motif.label;
    pathologieColor =
      eventInfo.event._def.extendedProps.motif &&
      eventInfo.event._def.extendedProps.motif.color;
  } catch (error) {
    console.error(error);
  }
  return eventInfo.event._def.extendedProps.type === 'rdv' ? (
    eventInfo.view.type === 'dayGridMonth' ? (
      <>
        <div
          className="fc-daygrid-event-dot"
          style={{ borderColor: eventInfo.borderColor, width: '2px', height: '2px' }}
        ></div>
        <div className="dot">
          {eventInfo.event._def.extendedProps.urlImg &&
          eventInfo.event._def.extendedProps.urlImg.includes('/') ? (
            <img
              style={{ borderRadius: '50%' }}
              width={30}
              height={30}
              src={`${process.env.REACT_APP_PUBLIC_URL}${eventInfo.event._def.extendedProps.urlImg}`}
            />
          ) : (
            <span style={{ verticalAlign: 'sub', fontWeight: 'bold' }}>
              {eventInfo.event._def.extendedProps.urlImg}
            </span>
          )}
        </div>
        <div className="fc-event-title">
          <div style={{ fontWeight: '400' }}>{eventInfo.event.title}</div>
          {eventInfo.event._def.extendedProps.type === 'rdv' ? (
            <div style={{ fontWeight: '400' }}>
              <span style={{ color: pathologieColor }}>
                {pathologie && pathologie.toString().slice(0, 15)}.
              </span>
              {' ' + moment(eventInfo.event.start).format('HH:mm')}
            </div>
          ) : (
            <div style={{ fontWeight: '400' }}>
              {moment(eventInfo.event.start).format('HH:mm') +
                ' - ' +
                moment(eventInfo.event.start).format('HH:mm')}
            </div>
          )}
        </div>
      </>
    ) : eventInfo.view.type === 'resourceTimeGridFourDay' ||
      eventInfo.view.type === 'resourceTimeGrid7Day' ? (
      <>
        {/*<div
          className="fc-daygrid-event-dot"
          style={{ borderColor: eventInfo.borderColor, width: '2px', height: '2px' }}
        ></div>*/}
        <div className="fc-event-title">
          <div style={{ fontWeight: 'bold', color: 'black' }}>
            {eventInfo.event.title}
          </div>
          <div style={{ fontWeight: '400', color: 'black' }}>
            {moment(eventInfo.event.start).format('HH:mm')}
          </div>
        </div>
      </>
    ) : (
      <>
        {/*<div
          className="fc-daygrid-event-dot"
          style={{ borderColor: eventInfo.borderColor, width: '2px', height: '2px' }}
        ></div>
        <div className="dot">
          {eventInfo.event._def.extendedProps.urlImg &&
          eventInfo.event._def.extendedProps.urlImg.includes('/') ? (
            <img
              style={{ borderRadius: '50%' }}
              width={30}
              height={30}
              src={`${process.env.REACT_APP_PUBLIC_URL}${eventInfo.event._def.extendedProps.urlImg}`}
            />
          ) : (
            <span style={{ verticalAlign: 'sub', fontWeight: 'bold' }}>
              {eventInfo.event._def.extendedProps.urlImg}
            </span>
          )}
        </div>*/}
        <div className="fc-event-title">
          <div style={{ fontWeight: 'bold', color: 'black' }}>
            {eventInfo.event.title}
            <span style={{ color: 'black', fontWeight: '400' }}>
              {'   ' +
                moment(eventInfo.event.start).format('HH:mm') +
                ' - ' +
                moment(eventInfo.event.end).format('HH:mm')}
            </span>
          </div>

          <div style={{ fontWeight: '400' }}>
            <span style={{ color: pathologieColor }}>
              {pathologie && pathologie.toString()}
            </span>
          </div>
        </div>
      </>
    )
  ) : (
    <div
      className="absenceDisplay"
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '10px',
        backgroundColor: 'gray',
        width: '-webkit-fill-available',
        borderRadius: '5px',
        border: '1px white',
        color: 'white',
      }}
    >
      <div className="dot">
        {eventInfo.event._def.extendedProps.urlImg &&
        eventInfo.event._def.extendedProps.urlImg.includes('/') ? (
          <img
            style={{ borderRadius: '50%' }}
            width={30}
            height={30}
            src={`${process.env.REACT_APP_PUBLIC_URL}${eventInfo.event._def.extendedProps.urlImg}`}
          />
        ) : (
          <span style={{ verticalAlign: 'sub', fontWeight: 'bold' }}>
            {eventInfo.event._def.extendedProps.urlImg}
          </span>
        )}
      </div>
      <div className="fc-event-title">
        <div style={{ fontWeight: 'bold' }}>{eventInfo.event.title}</div>
        <div style={{ fontWeight: '400' }}>
          {moment(eventInfo.event.start).format('HH:mm') +
            ' - ' +
            moment(eventInfo.event.end).format('HH:mm')}
        </div>
      </div>
    </div>
  );
};
class Calender extends React.Component {
  constructor(props) {
    super(props);
    props.getMedecins();
    props.getOfficeByIdDoctor();
    props.changeActiveItemSideBarCompta(null);
    props.getEmployeeManagement(true);
    props.getMotif();
    props.getAllDoctors(props.paramsDoctor);
    props.getAllRdvByDay({ ...props.params, date: new Date() }, []);
    props.changeNamePage('Agenda');
    props.changeActiveItemSideBar(1);
    props.changeActiveItemSideBarSettings(111, false, true);
    this.state = {
      value: 0,
      item: 0,
      date: props.params.date,
      updateRdv: false,
      typeView: 'dayGridMonth',
      update: false,
      checked: false,
      checkedStatus: false,
      statusList: [],
      showInput: false,
      hasError: false,
      anchor: false,
      setIsOpen: false,
      calendarWeekends: true,
      left: false,
      selected_id: null,
      listItem: ['Motif', 'Date', 'Créneau', 'Patient', 'Validation'],
      nameItem: 'Motif',
      regime: '',
      switchList: false,
      switchDuplicateRDV: false,
      showRightSideBar: false,
      showRightSideBarRDV: false,
      rdv: [],
      userList: [],
      userListName: [],
      rdvByDay: [],
      clickUser: false,
      showUnavailability: false,
      activeRDV: this.props.location.state ? this.props.location.state.showAddRdv : false,
      payment: {
        id: null,
        num_cheque: '',
        orde_virement: '',
        total_achieved: null,
        already_paid: null,
        left_to_pay: null,
        money_pot_amount: null,
        session_price: null,
        payment_method: null,
        settled_in_session: null,
        date: moment().format('YYYY-MM-DD'),
      },
      initialValues: {
        patient_id: null,
        motif: null,
        errorDate: false,
        errorHours: false,
        pr_number: '',
        labelMotif: '',
        first_name: '',
        last_name: '',
        phone: '',
        gender: '',
        address_patient: {
          city: '',
        },
        hour_end: '',
        hour_start: '',
        pathologie: '',
        diagnostic: '',
        labelMotif_update: '',
        date: moment().format('YYYY-MM-DD'),
        date_update: '',
        display_name: '',
        display_name_update: '',
        city: '',
        city_update: '',
        doctor_id: null,
        phone_number: '',
        phone_number_update: '',
        motif_id: null,
        motif_id_update: null,
        startDate: '',
        endDate: '',
        startHours: '',
        startHours_update: '',
        id_update: '',
        endHours: '',
        time: '',
        time_update: '',
        comment: '',
        name_btn_indispo: 'Ajouter',
        header_name_indispo: 'Ajouter une nouvelle indisponibilité',
      },
    };
    this.changeInitialValues = this.changeInitialValues.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleNextItem = this.handleNextItem.bind(this);
    this.handleSwitchList = this.handleSwitchList.bind(this);
    this.handleChangeInputPayment = this.handleChangeInputPayment.bind(this);
    this.handleSwitchDuplicateRDV = this.handleSwitchDuplicateRDV.bind(this);
    this.handleShowInput = this.handleShowInput.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleNextItem = this.handleNextItem.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.getStepContent = this.getStepContent.bind(this);
    this.getItemRdvDuplicated = this.getItemRdvDuplicated.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleInitialStateRDV = this.handleInitialStateRDV.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.goToPdf = this.goToPdf.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.getItemRdv = this.getItemRdv.bind(this);
    this.goToCure = this.goToCure.bind(this);
    this.toggleDrawerUpdate = this.toggleDrawerUpdate.bind(this);
  }

  handleInitialStateRDV() {
    this.props.changeSearched({
      ...this.props.paramsPatients,
      search: '',
    });
    this.setState({
      item: 0,
      hasError: false,
      initialValues: {
        ...this.state.initialValues,
        first_name: '',
        last_name: '',
        phone: '',
        gender: '',
        date: '',
        display_name: '',
        doctor_id: null,
        patient_id: null,
        city: '',
        labelMotif: '',
        phone_number: '',
        motif_id: null,
        startDate: '',
        endDate: '',
        startHours: '',
        endHours: '',
        time: '',
      },
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { initialValues, duplicateRdv, created, paymentAction, activeItemSideBarRDV } =
      this.props;
    if ((created || paymentAction) && this.state.showInput) {
      this.setState({
        switchList: false,
        showInput: !this.state.showInput,
      });
      this.handleInitialStateRDV();
      //this.openModal();
    }
    if (duplicateRdv !== prevProps.duplicateRdv) {
      this.setState({
        switchDuplicateRDV: false,
      });
      this.handleInitialStateRDV();
      //this.openModal();
    }
    if (created && activeItemSideBarRDV) {
      if (initialValues && !initialValues.motif_id) {
        this.setState({
          item: 0,
          hasError: false,
          update: false,
        });
      }
      this.props.changeActiveItemSideBarRDV(activeItemSideBarRDV);
      this.handleInitialStateRDV();
    }
    if (paymentAction !== prevProps.paymentAction && paymentAction) {
      this.setState({
        showInput: !this.state.showInput,
        setIsOpen: false,
      });
    }
  }
  calendarComponentRef = React.createRef();
  a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  toggleDrawerUpdate = (anchor, open, id) => (event) => {
    const { activeItemSideBarRDV } = this.props;
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    this.setState({
      left: open,
      anchor: 'left',
      selected_id: id,
      hasError: false,
      switchList: false,
      switchDuplicateRDV: false,
    });
  };
  toggleDrawer = (anchor, open, id) => (event) => {
    const { activeItemSideBarRDV } = this.props;
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    this.setState({
      left: open,
      anchor: 'left',
      selected_id: id,
      hasError: false,
      switchList: false,
      switchDuplicateRDV: false,
    });
    this.handleInitialStateRDV();
    this.props.changeActiveItemSideBarRDV(activeItemSideBarRDV);
  };
  handleNextItem(item) {
    const { initialValues } = this.state;
    const { patientRecords, getAllRDV } = this.props;

    let data = [];
    if (patientRecords && patientRecords.total > 0) data = patientRecords.data;
    if (item === 0 && !initialValues.doctor_id) {
      this.setState({
        hasError: true,
      });
    } else if (item === 0 && !initialValues.motif_id) {
      this.setState({
        hasError: true,
      });
    } else if (item === 0 && !initialValues.date) {
      this.setState({
        hasError: true,
      });
    } else if (item === 0 && !initialValues.startHours) {
      //|| !initialValues.endHours
      this.setState({
        hasError: true,
      });
    } else if (
      item === 0 &&
      moment(
        moment(`${initialValues.date} ${initialValues.startHours}`).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
      ).isSameOrAfter(
        moment(
          initialValues.endHours
            ? `${initialValues.date} ${initialValues.endHours}`
            : moment(
                `${initialValues.date} ${initialValues.startHours}`,
                'YYYY-MM-DD HH:mm:ss',
              )
                .add(30, 'minutes')
                .format('YYYY-MM-DD HH:mm:ss'),
        ).format('YYYY-MM-DD HH:mm:ss'),
      )
    ) {
      this.setState({
        hasError: true,
      });
    } else if (
      item === 1 &&
      data.length > 0 &&
      !initialValues.first_name &&
      !initialValues.patient_id
    ) {
      this.setState({
        hasError: true,
      });
    } else if (
      item === 1 &&
      data.length === 0 &&
      (!initialValues.last_name ||
        !initialValues.first_name ||
        !initialValues.city ||
        !initialValues.gender)
    ) {
      this.setState({
        hasError: true,
      });
    } else {
      if (item === 1 && initialValues.patient_id) {
        console.log(initialValues.date);
        const rdvs = getAllRDV.find(
          (element) =>
            element.patient_id === parseInt(initialValues.patient_id) &&
            moment(element.start, 'YYYY-MM-DD').isSame(
              moment(initialValues.date, 'YYYY-MM-DD'),
            ),
        );
        if (rdvs) {
          toast(
            ({ closeToast }) => (
              <ToastAction
                type="warning"
                message="Ce patient a déjà un RDV dans ce jour"
              />
            ),
            { hideProgressBar: true },
          );
        }
        console.log(rdvs);
      }
      this.setState({
        item: item + 1,
        hasError: false,
      });
    }
  }
  handleReset() {
    this.setState({
      item: 0,
      update: true,
    });
  }
  handleChangeInput(event) {
    const { initialValues } = this.state;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (name === 'startHours') {
      this.setState({
        initialValues: {
          ...initialValues,
          startHours: value,
          endHours: moment(
            moment(
              moment(`${initialValues.date} ${value}`).format('YYYY-MM-DD HH:mm:ss'),
              'YYYY-MM-DD HH:mm:ss',
            )
              .add(30, 'minutes')
              .format('YYYY-MM-DD HH:mm:ss'),
          ).format('HH:mm'),
        },
      });
    } else
      this.setState({
        initialValues: {
          ...initialValues,
          [name]: value,
        },
      });
  }
  handleCityChange(value) {
    const { initialValues } = this.state;
    this.setState({
      initialValues: {
        ...initialValues,
        city: value,
      },
    });
  }
  getStepContent(
    item,
    initialValues,
    motifs,
    getAllDayDispo,
    isLoadingGetAllDayDispo,
    params,
    hasError,
    getLastAvailabilityDate,
    isLoadingGetLastAvailability,
    isLoadingAddRdv,
    employeeManagement,
    userList,
    absenceHours,
  ) {
    const { isLoadingPatientRecords, paramsPatients, patientRecords } = this.props;
    let data = [];
    if (patientRecords && patientRecords.total > 0) data = patientRecords.data;
    switch (item) {
      case 0:
        return (
          <>
            <div className="right_sidebar_body" id="Motif">
              <div className="right_sidebar_body_control">
                <div className="right_side_shit_body_item-1">
                  <span id="motif_num">1</span>
                  <span id="motif_text"> Information générales</span>
                </div>
                <div className="right_side_shit_body_item-other">
                  <span id="motif_num_other">2</span>
                  <span id="motif_num_other">3</span>
                </div>
              </div>

              <hr style={{ width: '100%' }} id="top_section_seperator" />
              <div
                className={
                  hasError && !initialValues.doctor_id
                    ? 'right_sidebar_body_item type3'
                    : 'right_sidebar_body_item'
                }
              >
                <label>Collaborateur</label>
                <div className="input_and_icon">
                  <select
                    style={{ width: '100%' }}
                    value={initialValues.doctor_id}
                    onChange={this.handleChangeInput}
                    name="doctor_id"
                  >
                    <option value="">Collaborateur</option>
                    {employeeManagement.map((item) => {
                      return (
                        <option
                          value={item.id}
                        >{`${item.first_name} ${item.last_name}`}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="right_sidebar_body" id="Date">
              <hr style={{ width: '100%' }} id="top_section_seperator" />
              <div
                className={
                  hasError && !initialValues.motif_id
                    ? 'right_sidebar_body_item type3'
                    : 'right_sidebar_body_item'
                }
              >
                <label>Pathologie</label>
                <div className="input_and_icon">
                  <select
                    value={initialValues.motif_id}
                    style={{ width: '100%' }}
                    onChange={this.handleChangeInput}
                    name="motif_id"
                  >
                    <option value="">Pathologie</option>;
                    {motifs.map((item) => {
                      if (item.actif)
                        return <option value={item.id}>{item.label}</option>;
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="right_sidebar_body" id="Date">
              <hr style={{ width: '100%' }} id="top_section_seperator" />
              <div className="right_sidebar_body_item">
                <label>Date</label>
                <div className="input_and_icon">
                  <input
                    style={{ width: '100%' }}
                    value={initialValues.date}
                    name="date"
                    onChange={this.handleChangeInput}
                    className="form-control"
                    type="date"
                    placeholder="John Doe"
                  />
                </div>
              </div>
            </div>
            <div className="right_sidebar_body" id="Creneau">
              <hr style={{ width: '100%' }} id="top_section_seperator" />
              <div className="right_sidebar_body_item">
                <span className="creneau_container_title">Heure début</span>
                <div
                  className={
                    hasError &&
                    (!initialValues.startHours ||
                      (initialValues.startHours &&
                        initialValues.endHours &&
                        moment(
                          moment(
                            `${initialValues.date} ${initialValues.startHours}`,
                          ).format('YYYY-MM-DD HH:mm:ss'),
                        ).isSameOrAfter(
                          moment(
                            `${initialValues.date} ${initialValues.endHours}`,
                          ).format('YYYY-MM-DD HH:mm:ss'),
                        )))
                      ? 'creneau_container type3'
                      : 'creneau_container'
                  }
                  style={{ maxHeight: '300px', overflow: 'auto' }}
                >
                  <div className="input_and_icon" style={{ width: '100%' }}>
                    <input
                      style={{ width: '100%' }}
                      value={initialValues.startHours}
                      name="startHours"
                      onChange={this.handleChangeInput}
                      className="form-control"
                      type="time"
                      placeholder="John Doe"
                    />
                  </div>
                </div>
              </div>
              <div className="right_sidebar_body_item">
                <span className="creneau_container_title">Heure fin</span>
                <div
                  className={
                    hasError &&
                    initialValues.endHours &&
                    moment(
                      moment(`${initialValues.date} ${initialValues.startHours}`).format(
                        'YYYY-MM-DD HH:mm:ss',
                      ),
                    ).isAfter(
                      moment(`${initialValues.date} ${initialValues.endHours}`).format(
                        'YYYY-MM-DD HH:mm:ss',
                      ),
                    )
                      ? 'creneau_container type3'
                      : 'creneau_container'
                  }
                  style={{ maxHeight: '300px', overflow: 'auto' }}
                >
                  <div style={{ width: '100%' }} className="input_and_icon">
                    <input
                      style={{ width: '100%' }}
                      value={initialValues.endHours}
                      name="endHours"
                      onChange={this.handleChangeInput}
                      className="form-control"
                      type="time"
                      placeholder="John Doe"
                    />
                  </div>
                </div>
              </div>
              {absenceHours.length > 0 ? (
                <div className="right_sidebar_body_item">
                  <span style={{ color: 'red' }} className="creneau_container_title">
                    Collaborateur est absent
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </>
        );
      case 1:
        return (
          <div className="right_sidebar_body" id="Patient">
            <div className="right_sidebar_body_control">
              <div className="right_side_shit_body_item-1">
                <span id="motif_check_icon">
                  <i className="fas fa-check"></i>
                </span>
                <span id="motif_num">2</span>
                <span id="motif_text">Patient</span>
              </div>
              <div className="right_side_shit_body_item-other">
                <span id="motif_num_other">3</span>
              </div>
            </div>
            <hr style={{ width: '100%' }} id="top_section_seperator" />
            <div
              className={
                hasError && !initialValues.first_name && !initialValues.patient_id
                  ? 'right_sidebar_body_item type3'
                  : 'right_sidebar_body_item'
              }
            >
              <label>Prénom & Nom</label>
              <div className="input_and_icon">
                <input
                  style={{ width: '100%' }}
                  value={paramsPatients.search || ''}
                  onChange={(event) => {
                    this.props.changeSearched({
                      ...paramsPatients,
                      search: event.target.value ? event.target.value : '',
                    });
                  }}
                  //onChange={this.handleChangeInput}
                  className="form-control"
                  type="text"
                  placeholder="Prénom nom"
                />
              </div>
            </div>
            {data.length === 0 &&
            paramsPatients.search !== '' &&
            paramsPatients.search !== null ? (
              <>
                <Alert style={{ width: '100%' }} severity="info">
                  Essayez de créer un nouveau patient
                </Alert>
                <div className="add_patient_actual_form">
                  <div
                    style={{
                      width: '92%',
                    }}
                    className={
                      hasError && !initialValues.gender
                        ? `add_patient_form_item type3`
                        : 'add_patient_form_item'
                    }
                  >
                    <label>Civilité</label>
                    <div className="input_and_icon">
                      <select
                        value={initialValues.gender}
                        name="gender"
                        onChange={(e) => {
                          this.setState({
                            initialValues: {
                              ...initialValues,
                              gender: e.target.value,
                            },
                          });
                        }}
                        id="exampleFormControlSelect1"
                      >
                        <option value="" selected>
                          Choisissez la civilité
                        </option>
                        <option value="male">M.</option>
                        <option value="female">Mme.</option>
                      </select>
                    </div>
                  </div>
                  <div className="field_row">
                    <InputField
                      width="100%"
                      className="add_patient_form_item"
                      type="text"
                      placeholder="Prénom"
                      label="Prénom"
                      hasError={hasError}
                      validInput="string"
                      value={initialValues.last_name}
                      name="last_name"
                      icon={<i className="fas fa-user"></i>}
                      onChange={(e) => {
                        this.setState({
                          initialValues: {
                            ...initialValues,
                            last_name: e.target.value,
                          },
                        });
                      }}
                    />

                    <div style={{ width: '100%' }} className="add_patient_form_item">
                      <label>Ville</label>
                      <Autocomplete
                        id="size-small-standard"
                        size="small"
                        options={sortCities}
                        onChange={(event, option) => {
                          this.setState({
                            initialValues: {
                              ...initialValues,
                              city: option != null ? option.title : '',
                            },
                          });
                        }}
                        defaultValue={{
                          title: initialValues && initialValues.city,
                        }}
                        getOptionLabel={(option) => option.title}
                        renderInput={(cities) => (
                          <TextField
                            style={{ width: '100%' }}
                            placeholder="Ville"
                            {...cities}
                            variant="standard"
                            //value={initialValues.address_practitioner && initialValues.address_practitioner.city}
                            //label={<span>Ville <span style={{color: 'red'}}>*</span> </span>}
                            error={hasError && !initialValues.city}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="field_row">
                    <InputField
                      width="100%"
                      className="add_patient_form_item"
                      type="text"
                      placeholder="Nom"
                      validInput="string"
                      label="Nom"
                      hasError={hasError}
                      value={initialValues.first_name}
                      name="first_name"
                      icon={<i className="fas fa-user"></i>}
                      onChange={(e) => {
                        this.setState({
                          initialValues: {
                            ...initialValues,
                            first_name: e.target.value,
                          },
                        });
                      }}
                    />
                    <InputField
                      width="100%"
                      className="add_patient_form_item"
                      type="text"
                      minLength={8}
                      maxLength={20}
                      placeholder="Téléphone"
                      label="Téléphone"
                      hasError={hasError}
                      validInput="tel"
                      value={initialValues.phone}
                      name="phone"
                      icon={<i className="fas fa-phone-alt"></i>}
                      onChange={(e) => {
                        this.setState({
                          initialValues: {
                            ...initialValues,
                            phone: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
              </>
            ) : data.length > 0 &&
              paramsPatients.search !== '' &&
              paramsPatients.search !== null ? (
              <>
                <div style={{ height: '280px' }} className="contact_patients_body">
                  {isLoadingPatientRecords
                    ? ''
                    : data.length > 0
                    ? data.map((patient) => {
                        return (
                          <div
                            key={patient.id}
                            onClick={() => {
                              this.setState({
                                initialValues: {
                                  ...initialValues,
                                  patient_id: patient.id,
                                },
                              });
                              this.props.changeSearchedString({
                                ...paramsPatients,
                                search: `${patient.first_name} ${patient.last_name}`,
                              });
                            }}
                            className={`contact_patients_body_item ${
                              initialValues.patient_id === patient.id
                                ? 'selected_patient'
                                : ''
                            }`}
                          >
                            <div className="patient_contact_info_container">
                              <div className="patient_contact_img_container">
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.02734 9.35547C4.41016 8.79297 5.73438 8.51172 7 8.51172C8.26562 8.51172 9.57812 8.79297 10.9375 9.35547C12.3203 9.89453 13.0117 10.6094 13.0117 11.5V13.0117H0.988281V11.5C0.988281 10.6094 1.66797 9.89453 3.02734 9.35547ZM9.10938 6.12109C8.52344 6.70703 7.82031 7 7 7C6.17969 7 5.47656 6.70703 4.89062 6.12109C4.30469 5.53516 4.01172 4.83203 4.01172 4.01172C4.01172 3.19141 4.30469 2.48828 4.89062 1.90234C5.47656 1.29297 6.17969 0.988281 7 0.988281C7.82031 0.988281 8.52344 1.29297 9.10938 1.90234C9.69531 2.48828 9.98828 3.19141 9.98828 4.01172C9.98828 4.83203 9.69531 5.53516 9.10938 6.12109Z"
                                    fill="#8083A3"
                                  />
                                </svg>
                              </div>
                              <div className="patient_contact_info">
                                <span id="patient_contact_name">{`${patient.last_name} ${patient.first_name}`}</span>
                                <span id="patient_contact_city">
                                  {patient.address_patient &&
                                    patient.address_patient.city}{' '}
                                  {patient && patient.phone} {patient && patient.birthday}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ''}
                </div>
              </>
            ) : (
              ''
            )}
          </div>
        );
      case 2:
        const motif = motifs.find(
          (element) => element.id === parseInt(initialValues.motif_id),
        );
        const coll = employeeManagement.find(
          (element) => element.id === parseInt(initialValues.doctor_id),
        );
        const patient = data.find(
          (element) => element.id === parseInt(initialValues.patient_id),
        );
        return (
          <div className="right_sidebar_body" id="Validation">
            <div className="right_sidebar_body_control">
              <div className="right_side_shit_body_item-1">
                <span id="motif_check_icon">
                  <i className="fas fa-check"></i>
                </span>
                <span id="motif_check_icon">
                  <i className="fas fa-check"></i>
                </span>
                <span id="motif_num">3</span>
                <span id="motif_text">Validation</span>
              </div>
              <div className="right_side_shit_body_item-other"></div>
            </div>
            <hr id="top_section_seperator" />
            <div className="right_side_shit_body_item-1">
              <div className="validation_control">
                <span style={{ width: '60%' }} id="recap_text">
                  Récaputilatif
                </span>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.handleReset()}
                  className="edit_recap_btn"
                >
                  <i className="fas fa-pen" style={{ padding: '10px 5px' }}></i>Modifier
                </span>
              </div>
            </div>

            <hr id="top_section_seperator" />

            <div className="right_side_shit_body_item-1">
              <div className="recap_info_container">
                <div className="recap_info_additional_validation_control"></div>
                <div className="recap_info_main">
                  <div className="recap_info_container_header">
                    <div
                      style={{ width: '100px', height: '100px' }}
                      className="patient_avatar"
                    >
                      <svg
                        width="33"
                        height="34"
                        viewBox="0 0 33 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.73958 23.2812C9.42708 21.7812 12.9583 21.0312 16.3333 21.0312C19.7083 21.0312 23.2083 21.7812 26.8333 23.2812C30.5208 24.7188 32.3646 26.625 32.3646 29V33.0312H0.302084V29C0.302084 26.625 2.11458 24.7188 5.73958 23.2812ZM21.9583 14.6562C20.3958 16.2188 18.5208 17 16.3333 17C14.1458 17 12.2708 16.2188 10.7083 14.6562C9.14583 13.0938 8.36458 11.2188 8.36458 9.03125C8.36458 6.84375 9.14583 4.96875 10.7083 3.40625C12.2708 1.78125 14.1458 0.96875 16.3333 0.96875C18.5208 0.96875 20.3958 1.78125 21.9583 3.40625C23.5208 4.96875 24.3021 6.84375 24.3021 9.03125C24.3021 11.2188 23.5208 13.0938 21.9583 14.6562Z"
                          fill="#8083A3"
                        />
                      </svg>
                    </div>
                    <h5>
                      {patient
                        ? `${patient.last_name} ${patient.first_name}`
                        : `${initialValues.last_name} ${initialValues.first_name}`}
                    </h5>
                  </div>
                  <div className="recap_info_container_body">
                    <div className="motif_info">
                      <div className="motif_info_item">
                        <div className="motif_info_left_section">
                          <span>Collaborateur </span>
                        </div>
                        <div className="motif_info_right_section">
                          <span className="motif_info_prop">{`${
                            coll && coll.first_name
                          } ${coll && coll.last_name}`}</span>
                        </div>
                      </div>
                      <div className="motif_info_item">
                        <div className="motif_info_left_section">
                          <span>Pathologie </span>
                        </div>
                        <div className="motif_info_right_section">
                          <span className="motif_info_prop">{motif && motif.label}</span>
                        </div>
                      </div>

                      <div className="date_info_item">
                        <div className="date_info_left_section">
                          <span>Date</span>
                        </div>
                        <div className="date_info_right_section">
                          <span className="date_info_prop">
                            {moment(initialValues.date).format('DD/MM/YYYY')}
                          </span>
                        </div>
                      </div>
                      <div className="creneau_info_item">
                        <div className="creneau_info_left_section">
                          <span>Créneau</span>
                        </div>
                        <div className="creneau_info_right_section">
                          <span className="creneau_info_prop">
                            {initialValues.startHours}-{initialValues.endHours}
                          </span>
                        </div>
                      </div>
                      <div className="telephone_info_item">
                        <div className="telephone_info_left_section">
                          <span>Téléphone</span>
                        </div>
                        <div className="telephone_info_right_section">
                          <span className="telephone_info_prop">
                            {patient ? patient.phone : initialValues.phone}
                          </span>
                        </div>
                      </div>
                      <div className="ville_info_item">
                        <div className="ville_info_left_section">
                          <span>Ville</span>
                        </div>
                        <div className="ville_info_right_section">
                          <span className="motif_info_prop">
                            {patient
                              ? patient.address_patient && patient.address_patient.city
                              : initialValues.city}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_sidebar_footer confirm_btn_container">
              <button
                onClick={async () => {
                  await this.props.submitRDVForm(params, initialValues, userList);
                  //this.props.changeActiveItemSideBarRDV(true);
                }}
                className="confirm_recap_info_btn"
              >
                {isLoadingAddRdv ? (
                  <CircularProgress
                    style={{
                      marginLeft: '4%',
                      width: '35px',
                      height: '25px',
                      color: 'white',
                      animation: 'infinite',
                    }}
                  />
                ) : (
                  'Confirmer'
                )}
              </button>
            </div>
          </div>
        );
      default:
        return 'Unknown step';
    }
  }

  gotoPast = (date) => {
    const { userList } = this.state;
    let calendarApi = this.calendarComponentRef.current.getApi();
    this.props.getAllRdvByDay({ ...this.props.params, date }, userList);
    this.setState({
      date,
    });
    calendarApi.gotoDate(date);
  };
  getItemRdv(id) {
    const { getAllRDV, detailtPyamentRdv } = this.props;
    const rdv = getAllRDV.find((element) => element.id === parseInt(id));
    const { initialValues, paymentRdv } = this.state;
    if (
      rdv &&
      rdv.consultation &&
      rdv.consultation.id &&
      rdv.consultation.prise_en_charges &&
      rdv.consultation.prise_en_charges.length > 0 &&
      !rdv.consultation.prise_en_charges[0].code_bureau &&
      !rdv.consultation.prise_en_charges[0].year &&
      !rdv.consultation.prise_en_charges[0].num_order &&
      (rdv.regime === 'cnam' || rdv.regime === 'act')
    ) {
      toast(
        ({ closeToast }) => (
          <ToastAction type="warning" message="PEC n'est pas encore renseignée" />
        ),
        { hideProgressBar: true },
      );
    }
    this.setState({
      regime: rdv.regime,
      payment: {
        ...paymentRdv,
        id: rdv.payment ? rdv.payment.id : null,
        date_cheque: rdv.payment ? rdv.payment.date_cheque : '',
        orde_virement: rdv.payment ? rdv.payment.orde_virement : '',
        num_cheque: rdv.payment ? rdv.payment.num_cheque : '',
        total_achieved: rdv.payment ? rdv.payment.total_achieved : null,
        already_paid: rdv.payment ? rdv.payment.already_paid : null,
        left_to_pay: rdv.payment ? rdv.payment.left_to_pay : null,
        money_pot_amount: rdv.payment ? rdv.payment.money_pot_amount : null,
        /*session_price: rdv.consultation_price
          ? rdv.consultation_price
          : rdv.payment
          ? rdv.payment.session_price
          : null,*/
        session_price: rdv.payment
          ? rdv.payment.session_price
          : rdv.regime === 'cnam'
          ? rdv.motif.complement || rdv.consultation_price
          : rdv.regime === 'act'
          ? rdv.motif.price_medical_prescription || rdv.consultation_price
          : rdv.motif.price_with_out_cnam || rdv.consultation_price,
        // rdv.regime === 'cnam' && !rdv.payment
        //   ? 0
        //   : rdv.payment
        //   ? rdv.payment.session_price
        //   : rdv.consultation_price
        //   ? rdv.consultation_price
        //   : null,
        payment_method: rdv.payment ? rdv.payment.payment_method : 'Espèce',
        settled_in_session: rdv.payment ? rdv.payment.settled_in_session : null,
        date: rdv.payment
          ? moment(rdv.payment.date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      },
      initialValues: {
        ...initialValues,
        doctor: rdv.practitioner,
        num_cnam: rdv.num_cnam,
        price_with_out_cnam: rdv.motif.price_with_out_cnam,
        price_medical_prescription: rdv.motif.price_medical_prescription,
        consultation: rdv.consultation,
        consultation_id: rdv.consultation_id,
        patient_id: rdv.patient_id,
        id: rdv.id,
        id_update: rdv.id,
        note: rdv.note,
        pr_number: rdv.pr_number,
        doctor_id: rdv.practitioner_id,
        date_update: moment(rdv.start).format('YYYY-MM-DD'),
        display_name_update: rdv.display_name,
        city_update: rdv.city,
        city: rdv.city,
        status: rdv.status,
        labelMotif_update: rdv.motif.label === 'Autre' ? rdv.diagnostic : rdv.motif.label,
        phone_number_update: rdv.phone || '',
        motif_id_update: rdv.motif.id,
        motif_id: rdv.motif.id,
        startDate_update: moment(rdv.start).format('YYYY-MM-DD'),
        endDate: rdv.end,
        startHours: moment(rdv.start).format('HH:mm'),
        endHours: moment(rdv.end).format('HH:mm'),
      },
    });
    // this.props.getDipoDoctorByMotif({
    //   date: moment(rdv.date_from).format('YYYY-MM-DD'),
    //   motif_id: rdv.motif.id,
    //   rdv_id: rdv.id,
    // });
  }
  changeInitialValues(rdv) {
    const { initialValues, paymentRdv } = this.state;
    this.setState({
      regime:
        rdv.consultation &&
        rdv.consultation.id &&
        rdv.consultation.prise_en_charges &&
        rdv.consultation.prise_en_charges.length > 0
          ? rdv.consultation.prise_en_charges[0].regime
          : '',
      payment: {
        ...paymentRdv,
        id: rdv.payment ? rdv.payment.id : null,
        date_cheque: rdv.payment ? rdv.payment.date_cheque : '',
        orde_virement: rdv.payment ? rdv.payment.orde_virement : '',
        num_cheque: rdv.payment ? rdv.payment.num_cheque : '',
        total_achieved: rdv.payment ? rdv.payment.total_achieved : null,
        already_paid: rdv.payment ? rdv.payment.already_paid : null,
        left_to_pay: rdv.payment ? rdv.payment.left_to_pay : null,
        money_pot_amount: rdv.payment ? rdv.payment.money_pot_amount : null,
        /*session_price: rdv.consultation_price
          ? rdv.consultation_price
          : rdv.payment
          ? rdv.payment.session_price
          : null,*/
        session_price: rdv.payment
          ? rdv.payment.session_price
          : rdv.regime === 'cnam'
          ? rdv.motif.complement || rdv.consultation_price
          : rdv.regime === 'act'
          ? rdv.motif.price_medical_prescription || rdv.consultation_price
          : rdv.motif.price_with_out_cnam || rdv.consultation_price,
        // rdv.regime === 'cnam' && !rdv.payment
        //   ? 0
        //   : rdv.payment
        //   ? rdv.payment.session_price
        //   : rdv.consultation_price
        //   ? rdv.consultation_price
        //   : null,
        payment_method: rdv.payment ? rdv.payment.payment_method : 'Espèce',
        settled_in_session: rdv.payment ? rdv.payment.settled_in_session : null,
        date: rdv.payment
          ? moment(rdv.payment.date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      },
      initialValues: {
        ...initialValues,
        doctor: rdv.practitioner,
        num_cnam: rdv.num_cnam,
        price_with_out_cnam: rdv.motif.price_with_out_cnam,
        price_medical_prescription: rdv.motif.price_medical_prescription,
        consultation: rdv.consultation,
        consultation_id: rdv.consultation_id,
        patient_id: rdv.patient_id,
        id: rdv.id,
        id_update: rdv.id,
        note: rdv.note,
        pr_number: rdv.pr_number,
        doctor_id: rdv.practitioner_id,
        date_update: moment(rdv.date_from).format('YYYY-MM-DD'),
        display_name_update: `${rdv.patient.first_name} ${rdv.patient.last_name}`,
        city_update: rdv.city,
        city: rdv.city,
        status: rdv.status,
        labelMotif_update: rdv.motif.label === 'Autre' ? rdv.diagnostic : rdv.motif.label,
        phone_number_update: rdv.patient.phone || '',
        motif_id_update: rdv.motif.id,
        motif_id: rdv.motif.id,
        startDate_update: moment(rdv.date_from).format('YYYY-MM-DD'),
        endDate: rdv.date_to,
        startHours: moment(rdv.date_from).format('HH:mm'),
        endHours: moment(rdv.date_to).format('HH:mm'),
      },
    });
    // this.props.getDipoDoctorByMotif({
    //   date: moment(rdv.date_from).format('YYYY-MM-DD'),
    //   motif_id: rdv.motif.id,
    //   rdv_id: rdv.id,
    // });
  }
  getItemRdvDuplicated(rdv) {
    const { initialValues } = this.state;
    this.setState({
      initialValues: {
        ...initialValues,
        doctor: rdv.doctor,
        id: rdv.id,
        doctor_id: rdv.doctor.id,
        date: rdv.date_update,
        endDate: rdv.end,
        startHours: rdv.startHours,
        endHours: rdv.endHours,
      },
    });
    // this.props.getDipoDoctorByMotif({
    //   date: moment(rdv.date_from).format('YYYY-MM-DD'),
    //   motif_id: rdv.motif.id,
    //   rdv_id: rdv.id,
    // });
  }
  handleShowInput(val) {
    this.setState({
      showInput: val,
    });
  }
  handleChange = (event, value) => {
    this.setState({
      value,
    });
  };
  handleBack() {
    const { item } = this.state;
    this.setState({
      item: item - 1,
    });
  }
  handleChangeView(info) {
    this.setState({
      typeView: info.view.type,
    });
  }
  handleSwitchList() {
    this.setState({
      switchList: false,
    });
  }
  handleSwitchDuplicateRDV() {
    this.setState({
      switchDuplicateRDV: !this.state.switchDuplicateRDV,
    });
  }
  handleChangeInputPayment(event) {
    const { payment } = this.state;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      payment: {
        ...payment,
        [name]: value,
      },
    });
  }
  handleChangeSelect(event) {
    const {
      target: { value },
    } = event;
    const { employeeManagement } = this.props;
    let users = [];
    value.map((val) => {
      let user = employeeManagement.find(
        (item) => `${item.first_name} ${item.last_name}` === val,
      );
      users.push(user.id);
    });

    this.props.getAllRdvByDay(this.props.params, users);
    this.setState({
      userListName: typeof value === 'string' ? value.split(',') : value,
      userList: users,
      checked: true,
    });
  }
  //
  handleChangeStatus(event) {
    const {
      target: { value },
    } = event;
    let status = [];
    const { statusList, userList } = this.state;
    if (statusList.indexOf(value[0]) > -1)
      status = statusList.filter((item) => item !== value[0]);
    else status = [...statusList, value[0]];
    this.props.changeStatusRdv({ ...this.props.params, status: value }, userList);
    this.setState({
      statusList: typeof value === 'string' ? value.split(',') : value,
      checkedStatus: true,
    });
  }
  componentWillReceiveProps(nextProps, nextContext) {
    const { checked } = this.state;
    const { employeeManagement, getAllRDV } = nextProps;
    if (employeeManagement && employeeManagement.length > 0 && !checked) {
      let userListName = [];
      employeeManagement.map((user) =>
        userListName.push(`${user.first_name} ${user.last_name}`),
      );
      this.setState({ userListName, checked: true });
    }
    this.setState({ rdv: getAllRDV });
  }
  openModal() {
    this.setState({
      setIsOpen: !this.state.setIsOpen,
    });
  }
  goToCure(consultation_id) {
    this.props.history.push({
      pathname: `/consultations/${consultation_id}`,
      state: { consultation_id },
    });
  }
  goToPdf() {
    const { rdv } = this.state;
    const { office } = this.props;
    let rdvByDay = [];
    /*this.props.history.push({
      pathname: '/generate-rdv-pdf',
      state: { rdvByDay, office },
    });*/
    rdvByDay = rdv.filter((item) =>
      moment(moment(item.start).format('YYYY-MM-DD')).isSame(
        moment().format('YYYY-MM-DD'),
      ),
    );
    for (let i = 0; i < 40; i++) {
      rdvByDay.push({
        display_name: '',
        start: '',
        end: '',
      });
    }
    this.props.history.push({
      pathname: '/generate-rdv-pdf',
      state: { rdvByDay, office },
    });
    //rdvByDay
  }
  render() {
    const {
      initialValues,
      switchList,
      statusList,
      value,
      showInput,
      hasError,
      item,
      typeView,
      payment,
      userList,
      userListName,
      switchDuplicateRDV,
      date,
      regime,
      rdv,
    } = this.state;
    const {
      isLoadingAllSessionsPatient,
      allSessionsPatient,
      motifsAgenda,
      params,
      activeRDV,
      getAllRDV,
      getAllDayDispo,
      isLoadingGetAllDayDispo,
      getLastAvailabilityDate,
      isLoadingGetLastAvailability,
      isLoadingAddRdv,
      activeItemSideBarRDV,
      absenceHours,
      employeeManagement,
      isLoadingDuplicateRdv,
      user,
      detailtPyamentRdv,
      isLoadingDetailtPyamentRdv,
      patientStatistical,
      paramsPatients,
      office,
      medecins,
      loadingAddSessions,
      addPec,
      updateConsultation,
      account_type,
    } = this.props;
    return (
      <div style={{ padding: '10px' }} className="main_content_dashboard">
        <section className="section_dashboard">
          <div className="demo-app-top">
            <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="demo-multiple-name-label">Collaborateurs</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={userListName}
                onChange={this.handleChangeSelect}
                input={<OutlinedInput label="Collaborateurs" />}
                MenuProps={MenuProps}
                renderValue={(selected) => selected.join(', ')}
              >
                {employeeManagement.map((employee) => (
                  <MenuItem
                    key={employee.id}
                    value={`${employee.first_name} ${employee.last_name}`}
                  >
                    <Checkbox
                      checked={
                        userListName.indexOf(
                          `${employee.first_name} ${employee.last_name}`,
                        ) > -1
                      }
                    />
                    <ListItemText
                      primary={`${employee.first_name} ${employee.last_name}`}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <button onClick={this.toggleWeekends}>toggle weekends</button> */}
            {typeView !== 'dayGridMonth' ? (
              <input
                style={{
                  width: '20%',
                  marginRight: '1%',
                  //borderBottom: errorDate ? '1px solid #ff808b' : '',
                }}
                id="date"
                type="date"
                onChange={(e) => {
                  this.gotoPast(
                    e.target.value ? moment(e.target.value).format('YYYY-MM-DD') : '',
                  );
                }}
              />
            ) : (
              ''
            )}

            <select
              onChange={(e) => {
                this.props.changeType(
                  {
                    ...params,
                    type: e.target.value,
                  },
                  userList,
                );
              }}
              style={{
                width: '20%',
                marginRight: '1%',
                //borderBottom: errorDate ? '1px solid #ff808b' : '',
              }}
            >
              <option value="all">Choisissez</option>
              <option value="rdv">Rendez-vous</option>
              <option value="absence">Absence</option>
            </select>
            <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="demo-multiple-name-label">Statut</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label1"
                id="demo-multiple-checkbox1"
                multiple
                value={params.status}
                onChange={this.handleChangeStatus}
                input={<OutlinedInput label="Statut" />}
                MenuProps={MenuProps}
                renderValue={(selected) => {
                  let status = [];
                  selected.map((item) => {
                    if (item === 'not_confirmed') status.push('Non confirmé, ');
                    if (item === 'actif') status.push('Planifié, ');
                    if (item === 'completed') status.push('Terminé, ');
                    if (item === 'canceled') status.push('Annulé, ');
                  });
                  return status;
                }}
              >
                <MenuItem key={0} value="not_confirmed">
                  <Checkbox checked={params.status.indexOf('not_confirmed') > -1} />
                  <ListItemText primary="Non confirmé" />
                </MenuItem>
                <MenuItem value="actif" key={1}>
                  <Checkbox checked={params.status.indexOf('actif') > -1} />
                  <ListItemText primary="Planifié" />
                </MenuItem>
                <MenuItem value="completed" key={2}>
                  <Checkbox checked={params.status.indexOf('completed') > -1} />
                  <ListItemText primary="Terminé" />
                </MenuItem>
                <MenuItem value="canceled" key={3}>
                  <Checkbox checked={params.status.indexOf('canceled') > -1} />
                  <ListItemText primary="Annulé" />
                </MenuItem>
              </Select>
            </FormControl>
            {typeView === 'resourceTimeGridDay' ? (
              <button
                type="button"
                className="btn_valid"
                style={{
                  width: '115px',
                  marginRight: 'auto',
                  float: 'right',
                }}
                onClick={() => {
                  this.props.history.push({
                    pathname: '/generate-rdv-pdf',
                    state: { rdv, office, date },
                  });
                }}
              >
                <i className="fas fa-download" aria-hidden="true"></i> Planning
              </button>
            ) : (
              ''
            )}
          </div>
          <div className="demo-app-calendar">
            <FullCalendar
              firstDay={1}
              forceEventDuration={true}
              droppable={true}
              slotEventOverlap={false}
              //nowIndicator
              dateClick={(info) => console.log(info)}
              customButtons={{
                today: {
                  text: "Aujourd'hui",
                  click: async () => {
                    this.gotoPast(moment().format('YYYY-MM-DD'));
                  },
                },
                prev: {
                  click: async () => {
                    if (typeView === 'dayGridMonth')
                      this.gotoPast(moment(date).add(-1, 'months').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGrid7Day')
                      this.gotoPast(moment(date).add(-1, 'weeks').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGridDay')
                      this.gotoPast(moment(date).add(-1, 'days').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGridFourDay')
                      this.gotoPast(moment(date).add(-4, 'days').format('YYYY-MM-DD'));
                  },
                },
                next: {
                  click: () => {
                    if (typeView === 'dayGridMonth')
                      this.gotoPast(moment(date).add(1, 'months').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGrid7Day')
                      this.gotoPast(moment(date).add(1, 'weeks').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGridDay')
                      this.gotoPast(moment(date).add(1, 'days').format('YYYY-MM-DD'));
                    if (typeView === 'resourceTimeGridFourDay')
                      this.gotoPast(moment(date).add(4, 'days').format('YYYY-MM-DD'));
                  },
                },
              }}
              titleFormat={function (date) {
                if (typeView === 'dayGridMonth')
                  return `${moment(date.date).format('MMMM')} ${moment(date.date).format(
                    'YYYY',
                  )}`;
                if (
                  typeView === 'resourceTimeGrid7Day' ||
                  typeView === 'resourceTimeGridFourDay'
                )
                  return `De  ${moment(date.start).format('dddd')} ${moment(date.start)
                    .startOf('week')
                    .add(1, 'days')
                    .format('DD')} ${moment(date.date).format('MMMM')} à ${moment(
                    date.date,
                  )
                    .add(-3, 'days')
                    .format('dddd')} ${moment(date.date)
                    .endOf('week')
                    .add(-1, 'days')
                    .format('DD')} ${moment(date.end).format('MMMM')} ${moment(
                    date.end,
                  ).format('YYYY')}`;
                if (typeView === 'timeGridDay' || typeView === 'resourceTimeGridDay')
                  return `${moment(date.date).format('dddd')} ${moment(date.date).format(
                    'DD',
                  )} ${moment(date.date).format('MMMM')} ${moment(date.date).format(
                    'YYYY',
                  )}`;
              }}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right:
                  'dayGridMonth,resourceTimeGrid7Day,resourceTimeGridFourDay,resourceTimeGridDay',
                ///'dayGridMonth,dayGridWeek,dayGridDay,resourceTimeGridFourDay,resourceTimeGridDay',
              }}
              defaultView="dayGridMonth"
              initialView="resourceTimeGridDay"
              ref={this.calendarComponentRef}
              weekends={this.state.calendarWeekends}
              eventOrder={(a, b) => {
                var result = 0;
                if (a.sort < b.sort) result = -1;
                //event a should be listed first
                else if (a.sort > b.sort) result = 1; //event b should be listed first
                return result;
              }}
              views={{
                resourceTimeGrid7Day: {
                  type: 'resourceTimeGridWeek',
                  //duration: { days: 7 },
                  buttonText: 'Semaine',
                  startDays: 1,
                },
                resourceTimeGridFourDay: {
                  type: 'resourceTimeGridWeek',
                  duration: { days: 4, start: 1 },
                  buttonText: '4 jours',
                  startDays: 1,
                },
                resourceTimeGridDay: {
                  type: 'resourceTimeGridDay',
                  // duration: { days: 4, start: 1 },
                  buttonText: 'Jour',
                  startDays: 1,
                },
              }}
              viewDidMount={(info) => {
                this.setState({ typeView: info.view.type });
              }}
              viewClassNames={this.handleChangeView}
              resources={newDataEmployeeManagement(employeeManagement, userListName)}
              schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
              selectable={true}
              fixedWeekCount={false}
              //allDay={false}
              plugins={[
                //CustomView,
                dayGridPlugin,
                interactionPlugin,
                timeGridPlugin,
                resourceTimeGridPlugin,
              ]}
              dayMaxEventRows={true}
              eventClick={(event) => {
                if (
                  isHasPermission(
                    user.login_access.permissions,
                    'SHOW_APPOINTMENT_DETAILS',
                  ) &&
                  event.event._def.extendedProps.type === 'rdv'
                ) {
                  if (event.event._def.extendedProps.consultation_id) {
                    this.props.getDetailtPaymentAppointment(
                      event.event._def.extendedProps.consultation_id,
                    );
                  } else this.props.getDetailtPaymentAppointment(null);
                  this.setState({
                    switchList: true,
                  });
                  this.getItemRdv(parseInt(event.event._def.publicId));
                  this.props.getPatientStatistical(
                    parseInt(event.event._def.extendedProps.patient_id),
                  );
                  this.props.getPatientSessions(
                    parseInt(event.event._def.extendedProps.patient_id),
                  );
                }
              }}
              eventContent={EventDetail}
              events={rdv}
              select={(info) => {
                if (
                  isHasPermission(user.login_access.permissions, 'ADD_NEW_APPOINTMENT')
                ) {
                  this.setState({
                    initialValues: {
                      ...initialValues,
                      id: null,
                      doctor_id:
                        info.resource && info.resource._resource
                          ? info.resource._resource.id
                          : null,
                      date: moment(info.startStr).format('YYYY-MM-DD'),
                      startHours: !info.allDay
                        ? moment(info.startStr).format('HH:mm:ss')
                        : '',
                      endHours: !info.allDay
                        ? moment(info.endStr).format('HH:mm:ss')
                        : '',
                    },
                  });
                  this.props.changeSearched({
                    ...paramsPatients,
                    search: null,
                  });
                  this.props.changeActiveItemSideBarRDV(activeItemSideBarRDV);
                }
              }}
              eventDragStop={async (event, jsEvent) => {
                this.setState((prevState) => {
                  let data = [...prevState.rdv];
                  data = data.filter(
                    (item) => item.id !== parseInt(event.event._def.publicId),
                  );

                  this.setState({
                    initialValues: {
                      ...initialValues,
                      rdv: data,
                    },
                  });
                });
              }}
              eventLimit={true}
              editable={true}
              eventDrop={async (info) => {
                //<--- see from here
                if (info.event._def.extendedProps.type === 'rdv')
                  if (
                    isHasPermission(
                      user.login_access.permissions,
                      'ADD_NEW_APPOINTMENT',
                    ) &&
                    (info.event._def.extendedProps.status === 'completed' ||
                      info.event._def.extendedProps.status === 'canceled')
                  ) {
                    await this.props.duplicateRDVForm(
                      {
                        ...params,
                        date: moment(info.event._instance.range.start).format(
                          'YYYY-MM-DD',
                        ),
                      },
                      {
                        date: moment(info.event._instance.range.start).format(
                          'YYYY-MM-DD',
                        ),
                        endHours: moment(info.event._instance.range.end)
                          .tz('UTC')
                          .utc()
                          .format('HH:mm'),
                        startHours: moment(info.event._instance.range.start)
                          .tz('UTC')
                          .utc()
                          .format('HH:mm'),
                        id: parseInt(info.event._def.publicId),
                        doctor_id: parseInt(info.event._def.resourceIds[0]),
                      },
                      userList,
                    );
                  } else if (
                    isHasPermission(user.login_access.permissions, 'UPDATE_APPOINTMENT')
                  ) {
                    await this.props.submitRDVForm(
                      {
                        ...params,
                        date: moment(info.event._instance.range.start).format(
                          'YYYY-MM-DD',
                        ),
                      },
                      {
                        date: moment(info.event._instance.range.start).format(
                          'YYYY-MM-DD',
                        ),
                        endHours: moment(info.event._instance.range.end)
                          .tz('UTC')
                          .utc()
                          .format('HH:mm'),
                        startHours: moment(info.event._instance.range.start)
                          .tz('UTC')
                          .utc()
                          .format('HH:mm'),
                        id: parseInt(info.event._def.publicId),
                        doctor_id: parseInt(info.event._def.resourceIds[0]),
                      },
                      userList,
                    );
                  }
              }}
              locale={frLocale}
              slotMinTime="08:00:00"
              slotMaxTime="20:00:00"
              //timeZone="UTC"
            />
          </div>
        </section>
        <SwipeableDrawerDuplicate
          toggleDrawer={this.toggleDrawer}
          handleChangeInput={this.handleChangeInput}
          handleBack={this.handleBack}
          handleSwitchList={this.handleSwitchDuplicateRDV}
          handleInitialStateRDV={this.handleInitialStateRDV}
          changeActiveItemSideBarRDV={this.props.changeActiveItemSideBarRDV}
          activeItemSideBarRDV={activeItemSideBarRDV}
          getAllRDV={getAllRDV}
          switchDuplicateRDV={switchDuplicateRDV}
          item={item}
          initialValues={initialValues}
          motifs={motifsAgenda}
          getAllDayDispo={getAllDayDispo}
          isLoadingGetAllDayDispo={isLoadingGetAllDayDispo}
          params={params}
          hasError={hasError}
          getLastAvailabilityDate={getLastAvailabilityDate}
          isLoadingGetLastAvailability={isLoadingGetLastAvailability}
          isLoadingDuplicateRdv={isLoadingDuplicateRdv}
          employeeManagement={employeeManagement}
          userList={userList}
          absenceHours={absenceHours}
          duplicateRDVForm={this.props.duplicateRDVForm}
        />
        {isHasPermission(user.login_access.permissions, 'ADD_NEW_APPOINTMENT') ? (
          <SwipeableDrawerCreate
            toggleDrawer={this.toggleDrawer}
            handleNextItem={this.handleNextItem}
            getStepContent={this.getStepContent}
            handleCityChange={this.handleCityChange}
            handleChangeInput={this.handleChangeInput}
            handleBack={this.handleBack}
            handleSwitchList={this.handleSwitchList}
            handleInitialStateRDV={this.handleInitialStateRDV}
            changeActiveItemSideBarRDV={this.props.changeActiveItemSideBarRDV}
            changeSearched={this.props.changeSearched}
            activeItemSideBarRDV={activeItemSideBarRDV}
            activeRDV={activeRDV}
            item={item}
            initialValues={initialValues}
            motifs={motifsAgenda}
            getAllDayDispo={getAllDayDispo}
            isLoadingGetAllDayDispo={isLoadingGetAllDayDispo}
            params={params}
            hasError={hasError}
            getLastAvailabilityDate={getLastAvailabilityDate}
            isLoadingGetLastAvailability={isLoadingGetLastAvailability}
            isLoadingAddRdv={isLoadingAddRdv}
            employeeManagement={employeeManagement}
            userList={userList}
            absenceHours={absenceHours}
            submitRDVForm={this.props.submitRDVForm}
          />
        ) : (
          ''
        )}{' '}
        {isHasPermission(user.login_access.permissions, 'UPDATE_APPOINTMENT') ? (
          <SwipeableDrawerUpdate
            addPec={addPec}
            /*anchor={anchor}
            left={left}*/
            updateConsultation={updateConsultation}
            changeActiveItemSideBarRDV={this.props.changeActiveItemSideBarRDV}
            patientStatistical={patientStatistical}
            isLoadingAllSessionsPatient={isLoadingAllSessionsPatient}
            allSessionsPatient={allSessionsPatient}
            switchList={switchList}
            motifs={motifsAgenda}
            regime={regime}
            hasError={hasError}
            payment={payment}
            initialValues={initialValues}
            detailtPyamentRdv={detailtPyamentRdv}
            isLoadingDetailtPyamentRdv={isLoadingDetailtPyamentRdv}
            user={user}
            params={params}
            userList={userList}
            value={value}
            showInput={showInput}
            medecins={medecins}
            loadingAddSessions={loadingAddSessions}
            toggleDrawer={this.toggleDrawerUpdate}
            handleChangeInput={this.handleChangeInput}
            handleChange={this.handleChange}
            handleShowInput={this.handleShowInput}
            handleBack={this.handleBack}
            handleSwitchList={this.handleSwitchList}
            handleSwitchDuplicateRDV={this.handleSwitchDuplicateRDV}
            handleChangeInputPayment={this.handleChangeInputPayment}
            deleteRdv={this.props.deleteRdv}
            deleteSession={this.props.deleteSession}
            account_type={account_type}
            submitRDVForm={this.props.submitRDVForm}
            submitPaymentForm={this.props.submitPaymentForm}
            createConsultation={this.props.createConsultation}
            submitFormPEC={this.props.submitFormPEC}
            getItemRdvDuplicated={this.getItemRdvDuplicated}
            changeInitialValues={this.changeInitialValues}
            goToCure={this.goToCure}
          />
        ) : (
          ''
        )}{' '}
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Calender);
